import React from 'react';

interface OptimizedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string | { src: string } | any; // Erweitert für Vite-Image-Imports
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  loading?: 'lazy' | 'eager';
  sizes?: string;
}

/**
 * OptimizedImage-Komponente für optimierte Bildanzeige
 * 
 * Diese Komponente unterstützt verschiedene Bildtypen und Lazy Loading
 */
const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  width,
  height,
  className = '',
  loading = 'lazy',
  sizes = '100vw',
  ...props
}) => {
  // Verarbeiten der Bildquelle, egal ob als String oder als importiertes Modul
  // Für statische Importe in Vite stellt das Plugin sicher, dass der korrekte Pfad verwendet wird
  const imgSrc = typeof src === 'string' ? src : src?.default || src;

  // Stelle sicher, dass width und height vorhanden sind (wichtig für Cumulative Layout Shift)
  const imgWidth = width || undefined;
  const imgHeight = height || undefined;

  return (
    <img
      src={imgSrc}
      alt={alt}
      width={imgWidth}
      height={imgHeight}
      loading={loading}
      sizes={sizes}
      className={`${className}`}
      {...props}
    />
  );
};

export default OptimizedImage; 